import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

export class Esito {
  status: 'OK' | 'KO';
  msg: string;
  msg_secondLine: string;

  constructor(status: 'OK' | 'KO', msg: string, msg_secondLine: string) {
    this.status = status;
    this.msg = msg;
    this.msg_secondLine = msg_secondLine;
  }
}

@Component({
  selector: 'app-esito',
  templateUrl: './esito.component.html',
  styleUrls: ['./esito.component.scss']
})
export class EsitoComponent implements OnInit {

  esito: Esito | undefined;

  constructor(router: Router) {
    const state = router.getCurrentNavigation()?.extras?.state;
    if (state) {
      this.esito = state['esito'];
    }
  }

  ngOnInit(): void {
  }

}
